module.exports = __webpack_public_path__ + "static/read-blog-6e6f1a7e7ce0fcbf8c16a55e96b8d9cb.jpg";